import React from 'react';
import { FloatingScrollBar, } from '../FloatingScrollBar/FloatingScrollBar';
export function TableFloatingScrollBar(props) {
    return React.createElement(FloatingScrollBar, { ...props, dataHook: "table-floating-scroll-bar" });
}
//# sourceMappingURL=TableFloatingScrollBar.js.map